import { Menu } from "@headlessui/react";

export const CreditDebitNotesContextMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handleCreditDebitNotesRefundAmountPage,
    row
}) => {
    return (
        <>
        <Menu as="div" className="relative text-left">
														<div>
															<Menu.Button
																onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
																className="pt-1 pl-1 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
																title="More Actions..."
															>
																<svg
																	xmlns="http://www.w3.org/2000/svg"
																	fill="currentColor"
																	viewBox="0 0 24 24"
																	width="18"
																	height="18"
																>
																	<circle cx="12" cy="5" r="2" />
																	<circle cx="12" cy="12" r="2" />
																	<circle cx="12" cy="19" r="2" />
																</svg>
															</Menu.Button>
														</div>

														{anchorShipmentEl && (
															<Menu.Items className="absolute z-10 bg-white border border-gray-300 rounded shadow-lg w-60 p-1 max-h-60 overflow-y-auto" style={{ left: '-200px' }}>
																<div className="px-1 py-1">
																	{/* CreditDebitNotes Related Actions Section */}
																	<Menu.Item>
																		{({ active }) => (
																			<button
																				onClick={() => {
																					handleCreditDebitNotesRefundAmountPage(row);
																					setAnchorShipmentEl(null);
																				}}
																				className={`${active ? 'bg-gray-200' : ''
																					}  group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
																			// title="Refund Amount"
																			>
																				<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 193.769 193.769" width="28" height="24">
																					<path d="M149.203,41.104l-9.348,12.009c20.15,15.679,30.201,41.063,26.234,66.253c-2.906,18.484-12.838,34.73-27.964,45.748 c-15.131,11.012-33.64,15.488-52.124,12.567c-38.157-6.008-64.32-41.938-58.322-80.098C30.585,79.097,40.52,62.85,55.648,51.835 c13.208-9.615,28.991-14.233,45.086-13.317L87.579,52.319l9.759,9.313l20.766-21.801l0.005,0.008l9.303-9.769l-9.752-9.303 l-0.005,0.003L95.862,0l-9.31,9.769l14.2,13.525c-19.303-0.913-38.21,4.702-54.059,16.242 C28.28,52.943,16.19,72.717,12.65,95.221c-7.302,46.445,24.54,90.184,70.985,97.493c4.489,0.708,8.976,1.055,13.434,1.055 c17.89,0,35.273-5.623,50.011-16.356c18.415-13.409,30.503-33.183,34.043-55.682C185.952,91.077,173.72,60.181,149.203,41.104z"></path>
																					<path d="M105.24,151.971v-0.003h0.001v-8.757c10.383-1.159,20.485-7.718,20.485-20.17c0-16.919-15.732-18.859-27.223-20.274 c-7.347-0.878-12.97-1.897-12.97-6.348c0-6.188,8.722-6.855,12.473-6.855c5.567,0,11.507,2.617,13.525,5.957l0.586,0.971 l11.542-5.341l-0.571-1.164c-4.301-8.793-12.009-11.337-17.85-12.364v-7.71H91.723v7.677 c-12.582,1.856-20.054,8.839-20.054,18.829c0,16.29,14.791,17.943,25.582,19.153c9.617,1.134,14.094,3.51,14.094,7.469 c0,7.563-10.474,8.154-13.685,8.154c-7.147,0-14.038-3.566-16.031-8.301l-0.495-1.169l-12.539,5.316l0.5,1.169 c3.713,8.691,11.725,14.137,22.63,15.425v8.336H105.24z"></path>
																				</svg>
																				<span className='mx-3'>Refund Amount</span>
																			</button>
																		)}
																	</Menu.Item>

																</div>
															</Menu.Items>
														)}
													</Menu>
        </>
    )
}